export const Create = () => import("./Create.vue");
export const Edit = () => import("./Edit.vue");
export const List = () => import("./List.vue");
export const Show = () => import("./Show.vue");
export const Card = () => import("./Card.vue");
export const MyPending = () => import("./MyPending.vue");
